export default {"src":"/_next/static/media/javaIcon.ec30af0d.svg","height":32,"width":32};